import _slicedToArray from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import "core-js/modules/es6.regexp.constructor";
import _classCallCheck from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
var DEFAULT_SEPERATOR = '&';
var DEFAULT_KV_SEPERATOR = '=';
var KVParser = /*#__PURE__*/function () {
  function KVParser() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$seperator = _ref.seperator,
      seperator = _ref$seperator === void 0 ? DEFAULT_SEPERATOR : _ref$seperator,
      _ref$kvSeperator = _ref.kvSeperator,
      kvSeperator = _ref$kvSeperator === void 0 ? DEFAULT_KV_SEPERATOR : _ref$kvSeperator,
      _ref$skipEmpty = _ref.skipEmpty,
      skipEmpty = _ref$skipEmpty === void 0 ? false : _ref$skipEmpty,
      _ref$decode = _ref.decode,
      decode = _ref$decode === void 0 ? true : _ref$decode;
    _classCallCheck(this, KVParser);
    this._seperator = seperator;
    this._kvSeperator = kvSeperator;
    this._skipEmpty = skipEmpty;
    this._decode = decode;
  }
  _createClass(KVParser, [{
    key: "createPattern",
    value: function createPattern() {
      return new RegExp("([^\\".concat(this._seperator, "\\").concat(this._kvSeperator, "]+)(\\").concat(this._kvSeperator, "([^\\").concat(this._seperator, "\\").concat(this._kvSeperator, "]*))?"), 'g');
    }
  }, {
    key: "parse",
    value: function parse(content) {
      if (typeof content !== 'string' || content === '') {
        return {};
      }
      var regexp = this.createPattern();
      var params = {};
      var matches;
      while (matches = regexp.exec(content)) {
        var _matches = matches,
          _matches2 = _slicedToArray(_matches, 2),
          k = _matches2[1];
        var _matches3 = matches,
          _matches4 = _slicedToArray(_matches3, 4),
          v = _matches4[3];
        var isEmpty = v === null || v === undefined || v === '';
        if (this._skipEmpty && isEmpty) {
          continue;
        }
        if (isEmpty) {
          v = '';
        }
        params[k] = this._decode ? decodeURIComponent(v) : v;
      }
      return params;
    }
  }]);
  return KVParser;
}();
export { KVParser as default };